<div class="toastr-container">
  @for (toast of toastrService.toasts(); track toast.id) {
    <div
      class="toast-item"
      [class]="toast.type"
      (mouseenter)="toastrService.pause(toast.id)"
      (mouseleave)="toastrService.resume(toast.id)"
    >
      <div class="toast-icon">
        <i class="bi" [class]="iconFor(toast.type)"></i>
      </div>
      <div class="toast-body">
        <span class="toast-title">{{ titleFor(toast.type) }}</span>
        <span class="toast-message">{{ toast.message }}</span>
      </div>
      <button type="button" class="toast-close" (click)="toastrService.dismiss(toast.id)">
        <i class="bi bi-x-lg"></i>
      </button>
      @if (toast.duration > 0) {
        <div class="toast-progress" [style.animation-duration.ms]="toast.duration"></div>
      }
    </div>
  }
</div>
